import { useEffect } from "react";
import { IS_PLAYWRIGHT } from "@util/constant";
import Cookies from "js-cookie";

/**
 * Custom hook to redirect to the BTI version of an article if applicable.
 * It checks the user's country and preferred version before redirecting.
 *
 * @param {string} urlpath - The URL path of the article to redirect to.
 */
export const useArticleBTIRedirection = (urlpath?: string) => {
  useEffect(() => {
    console.log("[redirect] IS_PLAYWRIGHT", IS_PLAYWRIGHT); // eslint-disable-line no-console
    if (typeof window === "undefined") return;
    if (IS_PLAYWRIGHT) return;

    // Do nothing if article has no BTI reference
    const btiUrlPath = urlpath;
    console.log("[redirect] btiUrlPath", btiUrlPath); // eslint-disable-line no-console
    if (!btiUrlPath) return;

    // Do nothing if user is from SG
    const country = Cookies.get("sph_user_country");
    console.log("[redirect] country", country); // eslint-disable-line no-console
    if (country === "SG") return;

    // Do nothing if user preferred region is SG
    const preferredRegion = Cookies.get("preferred_region");
    console.log("[redirect] preferredRegion", preferredRegion); // eslint-disable-line no-console
    if (preferredRegion === "SG") return;

    console.log("[redirect] redirecting..."); // eslint-disable-line no-console
    // Redirect to BTI version of the article
    window.location.href = btiUrlPath;
  }, [urlpath]);
};
